import React, { useState } from 'react';
import { Button, TextField, CircularProgress, Typography } from '@mui/material';
// import Logo from "../../assets/logo.png";
import { Navigate, useNavigate } from 'react-router-dom';
import { primaryColor, secondaryColor } from '../../../constants/colors';
import useStyles from '../../../globalStyles';
import AuthBackground from '../../../components/authBackground';
import Swal from 'sweetalert2';
import { loginUser } from '../../../services/restaurant/index';
import axios from 'axios';
import { useAuth } from '../../../components/hooks/useAuth';
import { loginAdmin } from '../../../services/authentication';

const Login = () => {
  const classes = useStyles();
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    if (email == '' || password == '') {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Email & password are required',
        confirmButtonColor: 'red',
      });
    } else {
      let data = {
        email,
        password,
      };
      loginAdmin(data)
        .then((response) => {
          console.log(response, 'RESSSSSSSSSSSs');
          if (response.data.status == 'error') {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: response?.data?.message,
              confirmButtonColor: 'red',
            });
            setIsLoading(false);
          } else {
            let newObj = {
              ...response.data.data.userDetails,
            };
            setIsLoading(false);
            // localStorage.setItem('user_token', response.data.data.token);
            setEmail('');
            setPassword('');
            localStorage.setItem('user', JSON.stringify(newObj));
            login(response.data.data.userDetails);
            // window.location.pathname = "/";
          }
          console.log(response, 'Response===>');
        })
        .catch((error) => {
          console.log(error, 'ERRRRRRR');
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error?.response?.data?.message,
            confirmButtonColor: 'red',
          });
          setIsLoading(false);
          console.log(error.response, 'EROORRRRR');
        });
    }
  };

  if (user) {
    return <Navigate to='/' replace />;
  }

  return (
    <AuthBackground>
      <div className={classes.paper}>
        <Typography style={{ fontSize: '25px', fontWeight: '600' }}>
          Welcome!
        </Typography>
        <Typography style={{ fontWeight: '500' }}>
          Sign up or log in to continue
        </Typography>
        <TextField
          variant='outlined'
          margin='normal'
          required
          id='email'
          placeholder='Email'
          name='email'
          autoComplete='email'
          autoFocus
          value={email}
          className={classes.globalInput}
          onChange={(e) => setEmail(e.target.value)}
          onKeyPress={(e) => (e.key == 'Enter' ? handleLogin() : null)}
        />
        <TextField
          variant='outlined'
          margin='normal'
          required
          name='password'
          value={password}
          placeholder='Password'
          type='password'
          id='password'
          className={classes.globalInput}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={(e) => (e.key == 'Enter' ? handleLogin() : null)}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            margin: '10px 0',
          }}
        >
          <Typography
            onClick={() => navigate('/forgotPassword')}
            style={{ color: secondaryColor, cursor: 'pointer' }}
          >
            Forgot Password
          </Typography>
          {/* <Typography
            onClick={() => navigate('/signup')}
            style={{ cursor: 'pointer', colors: secondaryColor }}
          >
            Don't have an account ? Sign up
          </Typography> */}
        </div>
        <div style={{ textAlign: 'center', width: '100%' }}>
          {isLoading ? (
            <CircularProgress style={{ color: secondaryColor }} />
          ) : (
            <Button
              variant='contained'
              className={classes.loginBtn}
              size='small'
              onClick={handleLogin}
              disableRipple
            >
              <Typography className={classes.loginBtnText}>Sign In</Typography>
            </Button>
          )}
        </div>
      </div>
    </AuthBackground>
  );
};

export default Login;
